import React, { Component } from "react";

import BsyDashboardMenu from "../BsyDashboardMenu";
import BsyDashboardContent from "../BsyDashboardContent";
import BsyVirtualAddressBook from "../../BsyVirtualAddressBook";
import BsyVirtualReleaseManagement from "../../BsyVirtualReleaseManagement";

import { BsyUtils } from "../../../utils/Utils";
import "./index.css";
import { withRouter } from "react-router-dom";
import pubsub from "pubsub-js";

class BsyDashboard extends Component {
  constructor(props) {
    super(props);
    const { appid, type, entryid, groupid } = props.match.params;
    this.state = {
      routePath: props.match.path,
      appsCache: [],
      success: !1,
      virtualType: 1,
      appid: appid || "dashboard",
      type: type,
      entryid: entryid,
      groupid: groupid,
      apps: [],
      dockItem: [],
      dockCorp: [],
      dashboardMode: "dashboard", //工作台模式 dashboard 工作台  xxxxx 应用访问界面 allapp 全部应用界面
      components: [],
      appEmpty: false,
    };
  }

  selectApp = (appinfo) => {
    this.dashborderMenuContext.selectApp(appinfo);
  };

  onAllApp = () => {
    this.setState({
      dashboardMode: "allapp",
      appid: "allapp",
      appsCache: this._getCache(this.state.apps),
    });
  };

  getDashborderMenuContext = (context) => {
    this.dashborderMenuContext = context;
  };

  getDashborderContentContext = (context) => {
    this.dashborderContentContext = context;
  };
  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { appid, type, entryid, groupid } = nextProps.match.params;
    const appNewList = BsyUtils.Store.get("appNewList") || [];
    BsyUtils.Store.set(
      "appNewList",
      appNewList.filter((it) => it !== appid)
    );
    this.setState({
      appid: appid,
      type: type,
      routePath: nextProps.match.path,
      entryid: entryid,
      groupid: groupid,
      appsCache: this._getCache(this.state.apps),
    });
  }

  getUserInfo = (cb) => {
    React.axios("/team/getLocalDevInfo", {})
      .then((res) => {
        window.FX.STATIC = {
          ...window.FX.STATIC,
          user_corps: res.data.user_corps,
          corps: res.data.corps,
          user: res.data.user,
          VIP_PACK: res.data.VIP_PACK,
          sitesetting: res.data.sitesetting,
        };
        cb && cb();
      })
      .catch((res) => {
        console.error(res);
        cb && cb();
      });
  };

  initHistory = () => {
    const { routePath } = this.state;
    if (routePath === "/") {
      let key = "_appID_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
      if (BsyUtils.Store.get(key)) {
        let cache = BsyUtils.Store.get(key)[window.FX.STATIC.corpId];

        if (cache && cache.selectAppid) {
          if (cache[cache.selectAppid]) {
            if (!cache.user_id) {
              let obj = cache[cache.selectAppid];
              if (obj.appid && obj.type && obj.entryid) {
                this.props.history.push(
                  `${window.rootDirectroy}/team/app/${obj.appid}/${obj.type}/${obj.entryid}`
                );
              } else {
                this.props.history.push(
                  window.rootDirectroy + "/team/app/" + obj.appid
                );
              }
            }
          }
        }
      }
    }
  };

  componentDidMount = () => {
    const { appid } = this.props.match.params;
    const appNewList = BsyUtils.Store.get("appNewList") || [];
    BsyUtils.Store.set(
      "appNewList",
      appNewList.filter((it) => it !== appid)
    );
    if (window.localDev) {
      this.getUserInfo(() => {
        this.initHistory();
        this.applist();
        this.updateApps = pubsub.subscribe("updateApps", (topic, message) => {
          this.setState(
            {
              entryid: null,
            },
            () => {
              this.applist();
            }
          );
        });
      });
    } else {
      this.initHistory();
      this.applist();
      this.updateApps = pubsub.subscribe("updateApps", (topic, message) => {
        this.setState(
          {
            entryid: null,
          },
          () => {
            this.applist();
          }
        );
      });
    }
  };

  applist = () => {
    React.axios("/dashboard/app_group/list")
      .then(async (res) => {
        this.appMap = null;
        let standardAppData = []; //分组会混乱，所以不使用，标准应用在标准应用中请求

        let apps = this._getCache(
          res.data.dock_items
            ? [...res.data.items, ...res.data.dock_items, ...standardAppData]
            : [...res.data.items, ...standardAppData]
        );
        document.querySelector(".bsy-dashboard")?.classList?.add("ready");
        if (BsyUtils.isObjectEmpty(this.appMap)) {
          this.setState({
            appEmpty: true,
            success: !0,
            apps: [...res.data.items],
          });
        } else {
          this.setState({
            appsCache: apps,
            success: !0,
            dockItem: res.data.dock_items ? [...res.data.dock_items] : [],
            dockCorp: res.data.dock_corps ? [...res.data.dock_corps] : [],
            apps: [...res.data.items, ...standardAppData],
          });
        }
      })
      .catch((res) => {
        console.error(res);
      });
  };

  //查询app是否存在
  _findAppCache = (items, appId) => {
    if (!this.appMap) {
      this.appMap = {};
      items.map((data, index) => {
        data.apps.map((data1, index) => {
          this.appMap[data1._id] = data;
          return null;
        });
        return null;
      });
    }
    return !!this.appMap[appId];
  };

  _getCache = (items) => {
    let key = "_applist_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let apps = BsyUtils.Store.get(key) || [];
    if (BsyUtils.isObjectEmpty(apps)) {
      key = "_applist_" + window.FX.STATIC.corpId;
      apps = BsyUtils.Store.get(key) || [];
    }
    let appsCache = [];
    this._findAppCache(items);
    apps.map((data, index) => {
      if (this._findAppCache(items, data._id)) {
        appsCache.push(data);
      }
      return null;
    });
    return appsCache;
  };

  save = (components) => {
    this.setState({
      dashboardMode: "dashboard",
      appid: "dashboard",
      entryid: "",
      type: "",
      groupid: "",
      components: components,
    });
  };

  switchVirtualType = (t) => {
    this.setState({ virtualType: t });
  };

  render() {
    const {
      appsCache,
      appid,
      entryid,
      type,
      groupid,
      routePath,
      apps,
      dashboardMode,
      components,
      success,
      appEmpty,
      dockCorp,
      dockItem,
      virtualType,
    } = this.state;
    let app = {};
    apps.map((res) => {
      res.apps.map((res1) => {
        if (res1._id === appid) {
          app = res1;
        }
        return null;
      });
      return null;
    });
    return (
      <div className={"bsy-dashboard " + window.mode}>
        {success && (
          <>
            <BsyDashboardMenu
              virtualType={virtualType}
              getContext={this.getDashborderMenuContext}
              appsCache={appsCache}
              hasDesign={true}
              apps={apps}
              appid={appid}
              dockCorp={dockCorp}
              entryid={entryid}
              dockItem={dockItem}
              type={type}
              routePath={routePath}
              onAllApp={this.onAllApp}
              onSave={this.save}
              components={components}
              switchVirtualType={this.switchVirtualType}
              appEmpty={appEmpty}
              homeIcon={
                app.appType === 3
                  ? () => {
                      return <i class="icon-bby-iconzuofanhui"></i>;
                    }
                  : null
              }
              homeLink={app.appType === 3 ? "/team/standard" : null}
              homeHoveText={
                app.appType === 3
                  ? React.language("standard.application")
                  : null
              }
            />
            {(app.appType !== 3 || virtualType === 1) && (
              <BsyDashboardContent
                getContext={this.getDashborderContentContext}
                appid={appid}
                entryid={entryid}
                dockItem={dockItem}
                dockCorp={dockCorp}
                type={type}
                apps={apps}
                groupid={groupid}
                routePath={routePath}
                dashboardMode={dashboardMode}
                components={components}
                appEmpty={appEmpty}
              />
            )}
            {app.appType === 3 && virtualType === 2 && (
              <BsyVirtualAddressBook apps={apps} appid={appid} />
            )}
            {app.appType === 3 && virtualType === 3 && (
              <BsyVirtualReleaseManagement apps={apps} appid={appid} />
            )}
          </>
        )}
      </div>
    );
  }
}

export default withRouter(BsyDashboard);
